import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import "./ActionButton.scss";

const ActionButton = ({ icon, title, onClick, disabled = false, color, severity, outline = false }) => {
    const cls = [
        'action-btn',
        disabled  ? 'disabled'            : '',
        outline   ? 'outline'             : '',
        severity  ? `action-btn--${severity}` : '',
    ].filter(Boolean).join(' ');

    const btn = (
        <button className={cls} onClick={onClick} disabled={disabled} style={{ color }}>
            <span className="icon" data-icon={icon} />
        </button>
    );

    return title ? <Tooltip content={title}>{btn}</Tooltip> : btn;
};

export default ActionButton;
